import {
    IAllUserProjects,
    IEmployee,
    IExpense,
    INotification,
    IProject,
    IStatistic,
    ISummaryEmployee,
    ITask,
    ITimesheet,
    IUser
} from "../models";

export const initialState = () => {
    return {
        user: <IUser>{},
        accessToken: <string>"",
        refreshToken: <string>"",
        employees: <IEmployee[]>[],
        selectedEmployee: <IEmployee>{},
        language: <string>"",
        tasks: <ITask[]>[],
        expenses: <IExpense[]>[],
        timesheet: <ITimesheet[]>[],
        timesheetIdPerMonth: <{ month: string; timesheet_id: string; }[]>[],
        timesheetStatistic: <IStatistic[]>[],
        chosenTimesheet: <ITimesheet>{},
        summaryEmployees: <ISummaryEmployee[]>[],
        notifications: <INotification[]>[],
        allUserProjects: <IAllUserProjects>{
            used_projects: [],
            projects_list: []
        },

        projects: <IProject[]>[],

        summaryEmployeeIdOpen: <string>{},

        summaryFilter: <{ month: number; year: number; projectId?: string }>{
            month: new Date().getMonth() + 1,
            year: new Date().getFullYear(),
            projectId: undefined,
        },
    }
}